import { createSlice } from '@reduxjs/toolkit';

const angelUserSlice = createSlice({
  name: 'angelUser',
  initialState: {
    angelUserId: null,
  },
  reducers: {
    setAngelUserId: (state, action) => {
      state.angelUserId = action.payload;
    },
    angelLogout: (state) => {
      state.angelUserId = null;
      // Clear other user-related state here if needed
    },
  },
});

export const { setAngelUserId, angelLogout } = angelUserSlice.actions;
export default angelUserSlice.reducer;
